import React from 'react';
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";

const ProfileImage = ({entity, defaultImage = null}) => {

  return(
    <div
      className="navbar-user-button-image"
      style={{
        marginTop: -10,
        float: "left",
        position: "relative",
        top: 5,
        width: 48,
        height: 48,
        minWidth: 48,
        minHeight: 48,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        border: "2px solid white",
        backgroundPosition: "center",
        borderRadius: "50%",
        backgroundImage: `url(${makeImageUrlWithSize(entity, 'xs', defaultImage)})` }}
    />
  )
}
export default ProfileImage;